export enum HoaType {
  'yes' = 'yes',
  'no' = 'no',
  'to_be_determined' = 'to_be_determined',
}

export enum HoaTypeLabels {
  'yes' = 'Yes',
  'no' = 'No',
  'to_be_determined' = 'To be determined',
}
